<template>
  <tr class="rf-skeleton-row h-32">
    <td class="pr-0! whitespace-nowrap" style="min-width: calc(24px + 1rem)"></td>
    <td class="5xl:px-7! px-5! text-right whitespace-nowrap">
      <RfBaseSkeleton class="5xl:hidden! inline-flex!" width="40" />
      <RfBaseSkeleton class="5xl:inline-flex! hidden!" width="100" />
    </td>
    <td class="pl-0!">
      <div class="flex items-center gap-5">
        <div class="mr-1 block h-24 w-32 shrink-0">
          <RfBaseSkeleton width="128" height="96" radius="4" />
        </div>
        <div class="flex flex-col gap-3">
          <RfBaseSkeleton class="3xl:hidden! flex!" width="100" dynamic />
          <RfBaseSkeleton class="3xl:flex! hidden!" width="238" dynamic />
          <RfBaseSkeleton class="3xl:hidden! flex!" width="100" dynamic />
          <RfBaseSkeleton class="3xl:flex! hidden!" width="238" dynamic />
          <RfBaseSkeleton class="3xl:hidden! flex!" width="65" dynamic />
          <RfBaseSkeleton class="3xl:flex! hidden!" width="132" dynamic />
        </div>
      </div>
    </td>

    <td>
      <div class="4xl:w-40 flex w-24 flex-col gap-3">
        <template v-for="i in ~~(Math.random() * 3 + 1)" :key="i">
          <RfBaseSkeleton width="81" dynamic />
        </template>
      </div>
    </td>
    <td v-if="engagementCategoriesEnabled" class="w-0">
      <div class="4xl:w-32 flex w-24 flex-col items-start gap-2">
        <RfBaseSkeleton width="80" height="20" />
      </div>
    </td>
    <td class="px-4! text-start whitespace-nowrap"><RfBaseSkeleton width="59" /></td>
    <td class="px-4! text-start whitespace-nowrap"><RfBaseSkeleton width="59" /></td>
    <td class="bg-goal text-center"><RfBaseSkeleton width="60" /></td>
    <td class="bg-goal text-center"><RfBaseSkeleton width="60" /></td>
    <td class="bg-goal text-center"><RfBaseSkeleton width="60" /></td>
    <td class="px-2!"></td>
  </tr>
</template>

<script setup>
import RfBaseSkeleton from "@/components/skeletons/RfBaseSkeleton.vue";

defineProps({
  engagementCategoriesEnabled: { type: Boolean, default: false },
});
</script>
